import { UseCaseError } from '../../../core/errors/UseCaseError';

export class RejectFollowRequest {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(currentUserId, requesterId) {
    try {
      if (!currentUserId || !requesterId) {
        throw new UseCaseError('Les IDs des utilisateurs sont requis');
      }

      await this.userRepository.rejectFollowRequest(currentUserId, requesterId);
      console.log(`Demande d'abonnement refusée de ${requesterId} par ${currentUserId}`);
      return true;
    } catch (error) {
      console.error('Erreur dans RejectFollowRequest UseCase:', error);
      throw error;
    }
  }
} 